import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const userService = {
  register: (data) => {
    let uri = API_ROUTES.AUTHEN.REGISTER;
    return https.post(uri, data);
  },
  log_in: (identifier, password) => {
    let uri = API_ROUTES.AUTHEN.LOG_IN;
    return https.post(uri, {
      identifier: identifier,
      password: password,
    });
  },
  log_out: () => {
    let uri = API_ROUTES.AUTHEN.LOG_OUT;
    return https.post(uri, {});
  },
  forgot_password: (email) => {
    return https.post(API_ROUTES.AUTHEN.FORGOT, { email: email, type: "cms" });
  },
  verify_code: (email, code) => {
    return https.post(API_ROUTES.AUTHEN.VERIFY, { email, code, type: "cms" });
  },
  reset_password: (token, new_password) => {
    return https.post(API_ROUTES.AUTHEN.RESET, {
      token: token,
      newPassword: new_password,
      type: "cms",
    });
  },
  refresh_token: (refreshToken) =>
    https.post(API_ROUTES.AUTHEN.REFRESH_TOKEN, { refreshToken }),
};
